import PlainText from 'ati-ui-react/components/PlainText';
import React from 'react';

import UnknownErrorIcon from './icons/UnknownErrorIcon';
import i18nErrors from './errors';

import styles from './styles.module.scss';
import PropTypes from 'prop-types';

const ErrorPage = ({ locale }) => {
    const strings = i18nErrors[locale];

    return (
        <div className={styles['error-page']}>
            <div className={styles['content']}>
                <div className={styles['left']}>
                    <UnknownErrorIcon/>
                </div>
                <div className={styles['right']}>
                    <PlainText
                        secondary
                        size="medium"
                    >
                        {strings.subTitle}
                    </PlainText>
                    <PlainText
                        bold
                        className={styles['title']}
                    >
                        {strings.title}
                    </PlainText>
                    <PlainText
                        className={styles['subtitle']}
                        size="small"
                    >
                        {strings.description}
                    </PlainText>
                    <span className={styles['divider']}/>
                </div>
            </div>
        </div>
    );
};

ErrorPage.contextTypes = {
    siteFeatures: PropTypes.object,
};

ErrorPage.propTypes = {
    locale: PropTypes.string,
};

export default ErrorPage;
